<template>
    <div class="row">
        <div class="col-4">

            <div class="card">
                <div class="card-body">
                    <h5 class="card-title">Classes</h5>

                    <div v-show="classes.length ==0" class="alert alert-warning">
                        No classes defined
                    </div>
                    <ul class="list-group">
                        <li class="list-group-item" v-for="c in classes" v-bind:key="c.className">
                            <strong>{{c.className}}</strong> 
                            <span class="float-right">
                                <button class="btn btn-primary btn-sm" v-on:click.prevent="editClass(c)">Edit</button>
                            </span>
                        </li>
                    </ul>

                    <hr />

                    <h5 class="card-title">Add a new Class</h5>
                    <div class="form-group">
                        <input type="text" v-model="newClassName" v-mask="mask" class="form-control" placeholder="New Class Name" />
                    </div>
                    <div class="form-group">
                        <button class="btn btn-block btn-success" v-on:click.prevent="AddNewClass">Add Class</button>
                    </div>

                    <hr>
                    <h5 class="card-title">Options</h5>
                    <div class="form-check">
                        <label class="form-check-label">
                            <input class="form-check-input" type="checkbox" v-model="useVirtual" />
                            Use Virtual
                        </label>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-8">
            <div class="alert alert-info" v-if="currentClass == null">
                <span v-show="classes.length ==0">No classes exist. Add a new class to begin</span>
                <span v-show="classes.length >0">Select a class to edit from the menu</span>
            </div>
            <div class="form" v-if="currentClass != null">
                <fieldset>
                    <legend><strong>{{currentClass.className}}</strong> Class Definition</legend>                        
                    <div class="row">
                        <div class="col">
                            <div class="form-group">
                                <label>Class Name</label>
                                <input type="text" class="form-control" v-mask="mask" v-model="currentClass.className" />
                                <span v-show="classNameIsPlural" class="form-text text-danger">Class name is typically not pluralized. Try <strong>{{ singularClassName }}</strong> instead</span>
                            </div>
                        </div>
                    </div>

                    <h5>Properties</h5>
                    <div class="form-row">
                            <div class="col-3">
                                <label>Data Type</label>
                            </div>
                            <div class="col-4">
                                <label>Property Name</label>
                            </div>
                        </div>
                    <div v-for="p in properties" v-bind:key="p.id">
                        
                        <div class="form-row mb-1">
                            <div class="col-3">
                                <select class="form-control" v-model="p.dataType">
                                    <optgroup label="Built In">
                                        <option value="">Select Data Type...</option>
                                        <option value="int">int</option>
                                        <option value="string">string (text)</option>
                                        <option value="DateTime">DateTime</option>
                                        <option value="decimal">decimal (money)</option>
                                        <option value="long">long</option>
                                        <option value="bool">bool</option>
                                    </optgroup>
                                    <optgroup label="Relationships">
                                        <option v-for="c in classes" v-bind:key="c.className">{{c.className}}</option>
                                    </optgroup>
                                </select>
                            </div>
                            <div class="col-4"> 
                                <input v-model="p.propertyName" v-mask="mask" class="form-control" type="text" />
                            </div>
                            <div class="col-3">
                                <div v-if="propertyIsNullable(p)" class="form-check">
                                    <label class="form-check-label">
                                        <input class="form-check-input" type="checkbox" v-model="p.nullable" />
                                        Nullable
                                    </label>
                                </div>
                                <div v-if="propertyIsClass(p)" class="form-check">
                                    <label class="form-check-label">
                                        <input class="form-check-input" type="checkbox" v-model="p.hasMany" />
                                        Has Many
                                    </label>
                                </div>
                            </div>
                            <div class="col-2">
                                <button class="btn btn-danger btn-block" v-on:click.prevent="deleteProperty(p)">Delete</button>
                            </div>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="col-3">
                            <select class="form-control" v-model="dataType">
                                <option value="">Select Data Type...</option>
                                <optgroup label="Built In">
                                    <option value="int">int</option>
                                    <option value="string">string (text)</option>
                                    <option value="DateTime">DateTime</option>
                                    <option value="decimal">decimal (money)</option>
                                    <option value="long">long</option>
                                    <option value="bool">bool</option>
                                </optgroup>
                                <optgroup label="Relationships">
                                    <option v-for="c in classes" v-bind:key="c.className">{{c.className}}</option>
                                </optgroup>                                
                            </select>
                        </div>
                        <div class="col-4"> 
                            <input v-model="propertyName" v-mask="mask" class="form-control" type="text" />
                        </div>
                        <div class="col-3">
                            <div v-if="dataTypeIsNullable" class="form-check">
                                <label class="form-check-label">
                                    <input class="form-check-input" type="checkbox" v-model="nullable" />
                                    Nullable
                                </label>
                            </div>
                            <div v-if="dataTypeIsClass" class="form-check">
                                <label class="form-check-label">
                                    <input class="form-check-input" type="checkbox" v-model="hasMany" />
                                    Has Many
                                </label>
                            </div>
                        </div>
                        <div class="col-2">
                            <button class="btn btn-primary btn-block" v-on:click.prevent="addProperty">Add</button>
                        </div>
                    </div>
                </fieldset>
                    <div v-if="!doesIdPropertyExist" class="alert alert-danger mt-3">
                        This class must have a non-nullable <code>int</code> property called <strong>Id</strong> or <strong>{{currentClass.className}}Id</strong>
                        . This will become the primary key in the database.
                    </div>
                    <div v-if="missingForeignKeys.length>0">
                        <div v-for="m in missingForeignKeys" v-bind:key="m" class="alert alert-danger mt-3">
                            This class must have an <code>int</code> property called <strong>{{m}}Id</strong>
                            . This will become a foreign key in the database.
                        </div>
                    </div>

                    <div v-if="missingRelationships.length>0">
                        <div v-for="m in missingRelationships" v-bind:key="m" class="alert alert-danger mt-3">
                            {{m.description}}
                        </div>
                    </div>

                    <div v-if="extraForeignKeys.length>0">
                        <div v-for="m in extraForeignKeys" v-bind:key="m.id" class="alert alert-warning mt-3">
                            This class has an unexpected property called <strong>{{m.propertyName}}</strong>. 
                            You are likely adding a unneeded property. Foreign key properties only
                            need to be added to the "one" side of the relationship not the "many" side.
                        </div>
                    </div>

                    
                <hr>
                <pre class="rounded"><code>
public class {{currentClass.className}}
{
    <template v-for="p in properties">public {{getDataTypeDescription(p)}} {{p.propertyName}} { get; set; }
    </template>
}
                </code></pre>
 
            <div class="row">
                <div class="col text-right">
                    <button v-on:click="deleteClass(currentClass)" class="btn btn-danger">Delete <strong>{{currentClass.className}}</strong> class definition</button>
                </div>
            </div> 
            </div>                   
        </div>
    </div>
    
</template>

<style scoped>
    h4 {
        padding: 4px;
        font-size: 20px;
    }
    pre {
        padding: 10px;
        background-color: #eee;
    }
</style>

<script>
import _ from 'lodash'
import store from 'store2'
import pluralize from 'pluralize'
export default {
    data: function() {
        return {
            mask: "ANNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNN",
            classes: [],
            currentClass: null,
            propertyName: "",
            dataType: "",
            nullable: false,
            properties: [],
            newClassName: "",
            hasMany: false,
            useVirtual: false
        }
    },
    created() {
        let self = this;
        var data = store('data');
        if (data.length > 0) {
            self.classes = JSON.parse(data);
        }
        
    },
    watch: {
        classes: {
            deep: true,
            handler() {
                let self = this;
                store('data', JSON.stringify(self.classes));
            }
        }
    },
    methods: {
        editClass(c) {
            this.currentClass = c;
            this.properties = c.properties;
        },
        AddNewClass() {
            let self = this;
            console.log("adding new class ", self.newClassName);
            if (!self.newClassName == '') {
                let existing = _.find(self.classes, function(x) {
                    return x.className.toLowerCase() == self.newClassName.toLowerCase();
                });
                if (existing !== undefined) {
                    alert("You already have a class defined named " + this.newClassName);
                } else {
                   
                   if (pluralize.isPlural(self.newClassName) && !confirm("Class names are usually in the singular\nDo you want to continue to use " + self.newClassName + "?")) {
                       return;
                   }
                   
                   self.classes.push({
                        id: new Date().getTime(),
                        className: self.newClassName,
                        properties: []
                    });
                    self.newClassName = '';
                }
            }
        },
        getDataTypeDescription(p) {
            let self = this;

            if (self.propertyIsClass(p)) {
                if (p.hasMany) {
                    return (self.useVirtual ? "virtual " : "") + "List<" + p.dataType + '>'
                } else {
                    return (self.useVirtual ? "virtual " : "") + p.dataType
                }
            } else {
                return p.dataType + (p.nullable ? '?' : '');
            }
        },
        propertyIsClass(p) {
            let self = this;
             let existing = _.find(self.classes, function(x) {
                return x.className.toLowerCase() == p.dataType.toLowerCase();
            });
            return existing !== undefined;
        },
        propertyIsNullable(p) {
            var ts = ['int', 'decimal', 'long', 'bool', 'DateTime' ];
            return ts.includes(p.dataType);
        },
        addProperty() {
            let self=this;
            if (!self.propertyName || !self.dataType) {
                return;
            }

            if (self.hasMany && pluralize.isSingular(self.propertyName) && !confirm("\"Has many\" relationship property names are usually in the plural form.\nThe recommendation is to use " + pluralize.plural(self.propertyName) + "\n\nDo you want to continue to use " + self.propertyName + "?"))
            {
                return;
            }

            self.properties.push({
                dataType: self.dataType,
                propertyName: self.propertyName,
                nullable: self.nullable,
                hasMany: self.hasMany,
                id: new Date().getTime()
            });
            self.dataType = "";
            self.propertyName = "";
            self.nullable = false;
            self.hasMany = false;
        },
        deleteProperty(p) {
            if (confirm("Are you sure you want to delete this property?")){
                let self = this;
                let idx = self.properties.findIndex(function(x){
                    return x.id == p.id;
                });
                self.properties.splice(idx, 1);
            }
        },
        deleteClass(c) {
            if (confirm("Are you sure you want to delete this class definition?")){
                let self = this;
                let idx = self.classes.findIndex(function(x){
                    return x.id == c.id;
                });
                self.classes.splice(idx, 1);
                self.currentClass = null;
            }
        }
    },
    computed: {
        dataTypeIsNullable() {
            var ts = ['int', 'decimal', 'long', 'bool', 'DateTime' ];
            return ts.includes(this.dataType);
        },
        dataTypeIsClass() {
            let self = this;
            let existing = _.find(self.classes, function(x) {
                    return x.className.toLowerCase() == self.dataType.toLowerCase();
                });
            return existing !== undefined;
        },
        doesIdPropertyExist() {
            let self = this;
            let idP = _.find(self.properties, function(x) {
                return (x.propertyName == 'Id' || x.propertyName == self.currentClass.className + 'Id')
                        && x.dataType == 'int' && x.nullable == false;
            });

            return idP !== undefined;
        },
        expectedForeignKeys() {
            let self = this;
            let refs = _.filter(self.properties, function(x) {
                return x.hasMany == false && self.propertyIsClass(x);
            });

            return refs;
        },
        missingForeignKeys() {
            let self = this;
            let missing = [];
            let refs = self.expectedForeignKeys;

            if (refs.length > 0) {
                refs.forEach(element => {
                    let r = _.filter(self.properties, function(x) {
                        return x.propertyName == element.propertyName + 'Id';
                    });
                    if (r.length==0) {
                        missing.push(element.propertyName)
                    }
                });
            }

            return missing;
        },
        classNameIsPlural() {
            let self = this;
            if (self.currentClass == null) return false;
            return pluralize.isPlural(self.currentClass.className);
        },
        singularClassName() {
            let self = this;
            if (self.currentClass == null) return "";
            return pluralize.singular(self.currentClass.className);
        },
        missingRelationships() {
            let self = this;
            let refs = [];
            self.classes.forEach(c => {
                if (c.id !== self.currentClass.id) {
                    c.properties.forEach(p => {
                        if (p.dataType == self.currentClass.className) {
                            var hasRef = _.filter(self.properties, p=>{
                                return p.dataType == c.className;
                            });
                            if (hasRef.length ==0){

                                let expectedPlural = !p.hasMany;
                                let expectedName = pluralize(c.className, expectedPlural ? 2 : 1);

                                refs.push({
                                    className: c.className,
                                    propertyName: p.propertyName,
                                    hasMany: p.hasMany,
                                    description: 'Expecting a property of type ' + c.className + ' (with a property name called ' + expectedName + '). The "Has Many" checkbox will be ' + (expectedPlural ? 'checked' : 'unchecked')
                                });
                            }
                        }
                    });
                }
            });
            return refs;
        },
        extraForeignKeys() {
            let self = this;
            let extraProps = [];

            let refs = _.filter(self.properties, function(x) {
                return x.hasMany && self.propertyIsClass(x);
            });

            if (refs.length > 0) {
                refs.forEach(element => {
                    let r = _.filter(self.properties, function(x) {
                        return x.propertyName == element.propertyName + 'Id'
                        || x.propertyName == pluralize.singular(element.propertyName) +'Id'
                        || x.propertyName == element.propertyName + 'Ids'
                        || x.propertyName == pluralize.singular(element.propertyName) +'Ids'
                        || x.propertyName == pluralize.plural(element.propertyName) +'Id'
                        || x.propertyName == pluralize.plural(element.propertyName) +'Ids'
                    });

                    if (r.length>0) {
                        var fks = self.expectedForeignKeys;
                        r.forEach(p => {
                            var ffk = _.filter(fks, f => f.propertyName + "Id" == p.propertyName);
                            if (ffk.length == 0) {
                                extraProps.push(p);
                                return;
                            }
                        });
                    }
                });
            }
            return extraProps;
        }
    }
}
</script>